/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { VWQIcon } from "@sunwing/icons";
import { FluidSection } from "../../FluidSection";
import { useApp } from "../../hooks";
import config from "../../app/config";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./helpfulinfoVwq.module.scss");
  } else {
    styles = await import("./helpfulinfo.module.scss");
  }
})();

const SectionContent = ({
  currentInfo,
  selectedInfo,
  setSelectedInfo,
  locale,
}) => {
  const [expanded, setExpanded] = useState();
  const { userInfo } = useApp();

  const handleArrowClick = (info) => {
    if (selectedInfo.displayTitle === info.displayTitle) {
      setExpanded(!expanded);
    } else {
      setSelectedInfo(info);
    }
  };

  useEffect(() => {
    setExpanded(selectedInfo.displayTitle === currentInfo.displayTitle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInfo]);

  return (
    <div className={styles.sectionContainer}>
      <button
        data-accordion="tab"
        id={`${selectedInfo.sys.id}-trigger`}
        className={styles.sectionHeaderRow}
        aria-controls={`${selectedInfo.sys.id}-content`}
        aria-expanded={expanded}
        onClick={() => handleArrowClick(currentInfo)}
      >
        <span className={styles.sectionHeaderText}>
          {currentInfo.displayTitle}
        </span>
        <span className={styles.sectionHeaderIcon}>
          {expanded ? (
            <VWQIcon name="chevron-up-micro" className={styles.iconArrow} />
          ) : (
            <VWQIcon name="chevron-down-micro" className={styles.iconArrow} />
          )}
        </span>
      </button>
      {expanded && (
        <div
          data-accordion="content"
          tabIndex={expanded ? undefined : -1}
          role="region"
          id={`${selectedInfo.sys.id}-content`}
          aria-labelledby={`${selectedInfo.sys.id}-trigger`}
        >
          <FluidSection
            sections={Array.of(currentInfo)}
            selectedInfo={selectedInfo}
            userInfo={userInfo}
            locale={locale}
          />
        </div>
      )}
    </div>
  );
};

export default SectionContent;
